import { HttpBackend, HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { AuthConfig } from "angular-oauth2-oidc";
import { lastValueFrom } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class EnvService {
  environment = environment;
  http: HttpClient;

  constructor() {
    const httpBackend = inject(HttpBackend);

    this.loadConfig(environment);
    this.http = new HttpClient(httpBackend);
  }

  async loadExternalConfig() {
    try {
      const config = await lastValueFrom(this.http.get("config/config.json"));
      this.loadConfig(config);
    } catch (err) {
      console.log(
        "error loading config, will fallback to use environment defaults"
      );
      console.log(err);
    }
    console.table(this.environment);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private loadConfig(config: any) {
    for (const key in this.environment) {
      this.environment[key] = config[key];
    }
  }

  getLogoutUrl() {
    return (
      this.environment.issuerURI +
      "/logout?cb=none&revoke=token&revoke=token_refresh"
    );
  }

  getAuthCodeFlowConfig(): AuthConfig {
    return {
      issuer: this.environment.issuerURI,
      oidc: true,
      redirectUri: window.location.origin + window.location.pathname,
      clientId: this.environment.clientId,
      tokenEndpoint: this.environment.token_endpoint,
      responseType: "code",
      scope: this.environment.scopeUrl,
      requireHttps: false,
      useSilentRefresh: true,
      clearHashAfterLogin: false,
      revocationEndpoint: this.getLogoutUrl(),
    };
  }
}
